import { format } from 'date-fns';

/**
 * Format timestamp to Vietnamese date format
 * @param {number} timestamp - Unix timestamp in seconds
 * @param {string} formatStr - Format string (default: 'dd/MM/yyyy')
 * @returns {string} Formatted date string
 */
const formatDate = (timestamp, formatStr = 'dd/MM/yyyy') => {
    if (!timestamp) return '';
    
    try {
        // Convert seconds to milliseconds
        const date = new Date(timestamp * 1000);
        return format(date, formatStr);
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};

export default formatDate;
